module.exports = __webpack_public_path__ + "static/the-world-until-yesterday-31b9ce101f2603203c32213415c61123.jpg";